import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('demo@quoteplicity.com');
  const [password, setPassword] = useState('demo123');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F5F8FC', display: 'flex', flexDirection: 'column' }}>
      {/* Logo header */}
      <div style={{
        background: 'white',
        borderBottom: '1px solid #DDE7F1',
        padding: '16px 0',
        display: 'flex',
        justifyContent: 'center',
      }}>
        <div style={{ maxWidth: '200px' }}>
          <img src="/logo.svg" alt="Quoteplicity" style={{ height: '32px', width: 'auto' }} />
        </div>
      </div>

      {/* Login card */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', paddingBottom: '40px', paddingLeft: '16px', paddingRight: '16px' }}>
        <div className="portal-card" style={{ width: '100%', maxWidth: '420px', padding: '32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: '700', textAlign: 'center', marginBottom: '24px', color: '#0F172A' }}>
            Login
          </h2>

          {error && (
            <div className="alert-error" style={{ marginBottom: '16px' }}>
              <i className="fas fa-exclamation-circle mr-2"></i>{error}
            </div>
          )}

          <form data-testid="login-form" onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>
                Email
              </label>
              <input
                type="email"
                className="input-field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                data-testid="login-email-input"
              />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>
                Password
              </label>
              <input
                type="password"
                className="input-field"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                data-testid="login-password-input"
              />
            </div>

            <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" id="remember" defaultChecked style={{ cursor: 'pointer' }} />
              <label htmlFor="remember" style={{ fontSize: '13px', color: '#64748B', cursor: 'pointer' }}>Remember me</label>
            </div>

            <button
              type="submit"
              className="btn-primary"
              style={{ width: '100%', height: '42px', fontSize: '15px' }}
              disabled={loading}
              data-testid="login-form-submit-button"
            >
              {loading ? <><i className="fas fa-spinner fa-spin mr-2"></i>Logging in...</> : 'Login'}
            </button>

            <div style={{ textAlign: 'center', marginTop: '16px' }}>
              <Link to="/forgot-password" style={{ fontSize: '13px', color: '#2D87F0', textDecoration: 'none' }}>
                Forgot Password?
              </Link>
            </div>
          </form>

          <div className="alert-info" style={{ marginTop: '20px', fontSize: '12px' }}>
            <i className="fas fa-info-circle mr-1"></i>
            Demo: <strong>demo@quoteplicity.com</strong> / <strong>demo123</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
